export default __webpack_public_path__ + "static/media/calendar.1b20baa4.svg";